import { Player } from "@lottiefiles/react-lottie-player";
import squareLoader from "../../square-loader.json";
import { useAppLoading } from "./app-loading-provider";
export function AppLoadingOverlay({
  useGif = true,
  blur = true,
  overlayOpacity = 0.5,
  backdropClassName = "",
}) {
  const { isLoading, title, message } = useAppLoading();
  if (!isLoading) return null;

  return (
    <div
      className={[
        "fixed inset-0 z-[9999] flex items-center justify-center",
        `bg-black/${Math.round(overlayOpacity * 100)}`,
        blur ? "backdrop-blur-[1px]" : "",
        backdropClassName,
      ].join(" ")}
      role="status"
      aria-live="polite"
      aria-label={title || "Loading"}
    >
      <div
        className={[
          "w-full max-w-[280px] mx-4 rounded-2xl px-6 py-6 text-center text-white",
          title || message ? "bg-[#0B0D16]/90 border border-white/1" : "",
        ].join(" ")}
      >
        <div className="flex items-center justify-center mb-4 h-[64px]">
          {useGif ? (
            <Player src={squareLoader} className="player" autoplay loop />
          ) : (
            <i className="bi bi-arrow-repeat animate-spin text-[28px]" />
          )}
        </div>
        {title && (
          <h3 className="font-oswald text-[18px] leading-6 mb-1">{title}</h3>
        )}
        {message && (
          <p className="text-white/80 text-sm leading-5">{message}</p>
        )}
      </div>
    </div>
  );
}
